"use strict";

var _regeneratorRuntime = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var THREE = require("three"); // Don't like that we're targeting "examples"... but I tried out some other packages and they don't really seem to work


var EffectComposer_js_1 = require("three/examples/jsm/postprocessing/EffectComposer.js");

var RenderPass_js_1 = require("three/examples/jsm/postprocessing/RenderPass.js");

var ShaderPass_js_1 = require("three/examples/jsm/postprocessing/ShaderPass.js");

var FXAAShader_js_1 = require("three/examples/jsm/shaders/FXAAShader.js");

var OrbitControls_js_1 = require("three/examples/jsm/controls/OrbitControls.js");

var elements_manager_1 = require("./elements-manager");

var surface_1 = require("./surface");

var ThreeManager = function ThreeManager(plateComponents, screenDimensions, container, scale) {
  var _this = this;

  _classCallCheck(this, ThreeManager);

  this.surface = surface_1.surface;

  this.applyScale = function (plateComponents) {
    _this.scaleElements(plateComponents.elements);

    _this.scaleElements(plateComponents.additional);

    _this.scalePlate(plateComponents.plate);

    return plateComponents;
  };

  this.scaleElements = function (elements) {
    if (elements && elements.length > 0) {
      elements.forEach(function (element, index) {
        _this.scaleProps(element);

        if (typeof element.elements !== 'undefined') {
          _this.scaleElements(element.elements);
        }
      });
    }

    return elements;
  };

  this.scalePlate = function (plate) {
    _this.scaleProps(plate);

    return plate;
  };

  this.scaleProps = function (element) {
    if (element.position) {
      element.position.x = element.position.x * _this.scaleAdjustment;
      element.position.y = element.position.y * _this.scaleAdjustment;
      element.position.z = element.position.z * _this.scaleAdjustment;
    }

    if (element.scale) {
      element.scale.x = element.scale.x * _this.scaleAdjustment;
      element.scale.y = element.scale.y * _this.scaleAdjustment;
      element.scale.z = element.scale.z * _this.scaleAdjustment;
    }

    if (element.thickness) {
      element.thickness = element.thickness * _this.scaleAdjustment;
    }

    return element;
  };

  this.loadElements = function () {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.elementsManager.populatePlate(this.plateComponents.plate);
              this.elementsManager.populateElements([].concat(_toConsumableArray(this.plateComponents.additional), _toConsumableArray(this.plateComponents.elements))); // this.elementsManager.populateElements(this.plateComponents.additional);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
  };

  this.update = function (plateComponents, screenDimensions) {
    if (plateComponents) {
      plateComponents = _this.applyScale(plateComponents);

      if (plateComponents.elements) {
        plateComponents.elements = plateComponents.elements.filter(function (e) {
          return !e.hidden;
        });
      }

      if (plateComponents.components) {
        plateComponents.components = plateComponents.components.filter(function (e) {
          return !e.hidden;
        });
      }

      if (JSON.stringify(plateComponents) !== JSON.stringify(_this.plateComponents)) {
        _this.plateComponents = plateComponents; // console.log('new', JSON.parse(JSON.stringify(plateComponents)));
        // Clear and add elements

        _this.elementsManager.clear();

        _this.renderer.renderLists.dispose();

        _this.loadElements(); // Updating camera positions


        var _position = new THREE.Vector3(plateComponents.plate.scale.x / 2, plateComponents.plate.position.y * 1.1, plateComponents.plate.position.z); // this.floor.position.set(position.x, 0, 0);


        _this.controls.target.set(_position.x, _position.y, _position.z);

        _this.controls.update();
      }
    } // const position = new THREE.Vector3(this.plateComponents.plate.scale.x / 2, this.plateComponents.plate.position.y as number, 0);
    // Update plateComponents if present and different
    // If screenDimensions exists and is different, then set and call onWindowResize event or something I guess
    // if (screenDimensions && JSON.stringify(screenDimensions) !== JSON.stringify(this.screenDimensions)) {
    //   this.camera = this.buildCamera(screenDimensions, position);
    //   // this.renderer.setSize(screenDimensions.width, screenDimensions.height, false);
    //   // this.renderer.setViewport(0, 0, screenDimensions.width, screenDimensions.height);
    //   this.renderer.setSize(screenDimensions.width, screenDimensions.height, false);
    //   this.controls = this.buildControls(this.camera, this.renderer, position, this.render);
    //   // FXAA from composer
    //   // setTimeout(() => {
    //   //   this.container.innerHTML = '';
    //   //   this.renderer = this.buildRenderer(screenDimensions, this.container);
    //   // }, 500);
    //   this.render();
    // }

  };

  this.buildScene = function () {
    var scene = new THREE.Scene();
    scene.background = new THREE.Color(0xffffff);
    return scene;
  };

  this.buildCamera = function (screenDimensions, position) {
    var aspectRatio = screenDimensions.width / screenDimensions.height;
    var fieldOfView = 60;
    var nearPlane = 0.1;
    var farPlane = 1000; // orbitcontrols is to be used for the camera to adjust the rotation and zoom capabilities.

    var camera = new THREE.PerspectiveCamera(fieldOfView, aspectRatio, nearPlane, farPlane);
    camera.lookAt(new THREE.Vector3(0, 1.2, position.z)); // camera.zoom = 5;

    camera.position.set(position.x, 1.75, 2.5);
    return camera;
  };

  this.buildRenderer = function (screenDimensions, container) {
    var renderer = new THREE.WebGLRenderer({
      preserveDrawingBuffer: true
    });
    renderer.setClearColor(0xffffff, 1);
    renderer.setSize(screenDimensions.width, screenDimensions.height);
    container.appendChild(renderer.domElement);
    return renderer;
  };

  this.buildComposer = function (screenDimensions, scene, camera, renderer) {
    var renderModel = new RenderPass_js_1.RenderPass(scene, camera);
    var effectFXAA = new ShaderPass_js_1.ShaderPass(FXAAShader_js_1.FXAAShader);
    effectFXAA.uniforms['resolution'].value.set(1 / screenDimensions.width, 1 / screenDimensions.height);
    var composer = new EffectComposer_js_1.EffectComposer(renderer);
    composer.addPass(renderModel);
    composer.addPass(effectFXAA);
    return composer;
  };

  this.buildControls = function (camera, renderer, position, render) {
    var controls = new OrbitControls_js_1.OrbitControls(camera, renderer.domElement); // Limiting the controls using node_env
    // if (process.env.NODE_ENV !== 'development') {

    controls.enablePan = false;
    controls.minAzimuthAngle = -0.8;
    controls.maxAzimuthAngle = 0.8;
    controls.maxDistance = 4.0;
    controls.minDistance = 1.0;
    controls.maxPolarAngle = 2.2;
    controls.minPolarAngle = 0.92; // }

    controls.target.copy(position);
    controls.addEventListener('change', render); // Updating position of controls just in case...

    controls.update();
    setTimeout(function () {
      controls.update();
    }, 1); // With offset as well just in case...

    return controls;
  };

  this.populateLights = function (scene) {
    var ambientLight = new THREE.AmbientLight(0x777777);
    scene.add(ambientLight);
    var pointLight = new THREE.PointLight(0x666666, 1, 22);
    pointLight.position.set(4, 4, 17);
    scene.add(pointLight);
    var directionalLight = new THREE.DirectionalLight(0x888888);
    directionalLight.position.set(0.5, 1.3, 0.5).normalize();
    scene.add(directionalLight);
  };

  this.populateHelpers = function (scene) {
    // Helper
    var gridHelper = new THREE.AxesHelper(5);
    scene.add(gridHelper);
  };

  this.onWindowResize = function () {
    var width = _this.screenDimensions.width;
    var height = _this.screenDimensions.height;
    _this.camera.aspect = width / height;

    _this.camera.updateProjectionMatrix();

    _this.composer.setSize(width, height);

    _this.renderer.setSize(width, height); // this.effectFXAA.uniforms['resolution'].value.set(1 / width, 1 / height); // Might want to refresh anti-aliasing, we'll know for sure later

  };

  this.render = function () {
    _this.composer.render();
  }; // Defaults


  if (!screenDimensions) {
    this.screenDimensions = {
      width: window.innerWidth,
      height: window.innerHeight
    };
  } else {
    this.screenDimensions = screenDimensions;
  }

  if (!scale) {
    this.scaleAdjustment = 0.001; // 0.00104; // 0.00104;
  } else {
    this.scaleAdjustment = scale;
  }

  if (!container) {
    this.container = document.createElement('div');
    document.body.appendChild(this.container);
  } else {
    this.container = container;
  } // Scene


  this.scene = this.buildScene(); // Camera

  var position = new THREE.Vector3(plateComponents.plate.scale.x * this.scaleAdjustment / 2, plateComponents.plate.position.y * this.scaleAdjustment * 1.1, plateComponents.plate.position.z * this.scaleAdjustment);
  this.camera = this.buildCamera(this.screenDimensions, position); // Renderer

  this.renderer = this.buildRenderer(this.screenDimensions, this.container); // Composer

  this.composer = this.buildComposer(this.screenDimensions, this.scene, this.camera, this.renderer); // Controls

  this.controls = this.buildControls(this.camera, this.renderer, position, this.render); // Basic environment setup

  this.populateLights(this.scene); // Populate elements

  this.elementsManager = new elements_manager_1.default(this.scene, this.render);
  this.update(plateComponents); // Events

  window.addEventListener('resize', this.onWindowResize, false); // Maybe not needed? 
};

exports.ThreeManager = ThreeManager;
exports.default = ThreeManager;